/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import Auth from '../Auth';
import Form from '../../../../../components/Form';
import Text from '../../../../../components/Form/Input/Text';
import history from '../../../../../history';

const messages = defineMessages({
  hours: {
    id: 'auth.hours.hours',
    defaultMessage: 'What are your salon hours?',
    description: 'What are your salon hours Message',
  },
  step4: {
    id: 'auth.hours.step4',
    defaultMessage: 'STEP 4 OF 5',
    description: 'step4',
  },

  monday: {
    id: 'auth.hours.monday',
    defaultMessage: 'Monday',
    description: 'Monday',
  },
  tuesday: {
    id: 'auth.hours.tuesday',
    defaultMessage: 'Tuesday',
    description: 'Tuesday',
  },
  wednesday: {
    id: 'auth.hours.wednesday',
    defaultMessage: 'Wednesday',
    description: 'Wednesday',
  },
  thursday: {
    id: 'auth.hours.thursday',
    defaultMessage: 'Thursday',
    description: 'Thursday',
  },
  friday: {
    id: 'auth.hours.friday',
    defaultMessage: 'Friday',
    description: 'Friday',
  },
  saturday: {
    id: 'auth.hours.saturday',
    defaultMessage: 'Saturday',
    description: 'Saturday',
  },
  sunday: {
    id: 'auth.hours.sunday',
    defaultMessage: 'Sunday',
    description: 'Sunday',
  },

  startTime: {
    id: 'auth.hours.startTime',
    defaultMessage: 'Start Time',
    description: 'Start Time',
  },
  endTime: {
    id: 'auth.hours.endTime',
    defaultMessage: 'End Time',
    description: 'End Time',
  },

  btn1: {
    id: 'auth.hours.btn1',
    defaultMessage: '...submitting',
    description: 'btn1',
  },
  btn2: {
    id: 'auth.hours.btn2',
    defaultMessage: 'CONTINUE',
    description: 'btn2',
  },
});

class Hours extends Component {
  static contextTypes = {
    url: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.state = {
      submitting: false,
      submitSuccess: false,
      submitError: false,
      value: {},
    };
  }

  async onValidSubmit(e) {
    const { siteId } = this.context.routeParams;
    this.setState({
      value: e.value,
      submitting: true,
      submitSuccess: false,
      submitError: false,
    });
    const resp = await this.context.fetch(`/${siteId}/auth/register/hours`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(e.value),
      credentials: 'include',
    });
    const data = await resp.json();
    if (!data || resp.status !== 200 || data.responseCode === 1) {
      this.setState({
        submitError: true,
        submitErrorMessage: data.responseDesc,
        submitting: false,
      });
    } else {
      this.setState(
        {
          submitting: false,
          submitError: false,
          submitSuccess: true,
          value: {},
        },
        () => history.push(`/${siteId}/auth/avatar`),
      );
    }
  }

  render() {
    const { title } = this.props;
    const { intl } = this.context;
    const days = [
      intl.formatMessage(messages.monday),
      intl.formatMessage(messages.tuesday),
      intl.formatMessage(messages.wednesday),
      intl.formatMessage(messages.thursday),
      intl.formatMessage(messages.friday),
      intl.formatMessage(messages.saturday),
      intl.formatMessage(messages.sunday),
    ];
    const formElements = [];
    days.forEach((day, index) => {
      formElements.push(
        <div className="row" key={day}>
          <div className="small-4 columns auth__weekday">{day}</div>
          <div className="small-4 columns">
            <Text
              label={intl.formatMessage(messages.startTime)}
              helpText=""
              errorText=""
              name={`hours.open-${index}`}
            />
          </div>
          <div className="small-4 columns">
            <Text
              label={intl.formatMessage(messages.endTime)}
              helpText=""
              errorText=""
              name={`hours.close-${index}`}
            />
          </div>
        </div>,
      );
    });

    return (
      <Auth>
        <div className="auth__form">
          <div className="auth__step">
            <FormattedMessage {...messages.step4} />
          </div>
          <div className="auth__step-info">
            <FormattedMessage {...messages.hours} />
          </div>
          <div className="auth__main">
            <Form
              title={title}
              // onInvalidSubmit={this.onInvalidSubmit.bind(this)}
              onValidSubmit={this.onValidSubmit}
              // onSubmit={this.onSubmit.bind(this)}
              // onChange={this.onChange.bind(this)}
              // onCancel={this.onCancel.bind(this)}
              // onInit={this.onInit.bind(this)}
              // value={this.state.value}
              value={this.state.value}
              isSubmitting={this.state.submitting}
              submitButtonLabel={
                this.state.submitting
                  ? intl.formatMessage(messages.btn1)
                  : intl.formatMessage(messages.btn2)
              }
            >
              {formElements}
            </Form>
          </div>
        </div>
      </Auth>
    );
  }
}

export default Hours;



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/hours/Hours.js